import { Component, OnInit, ChangeDetectionStrategy, Injector } from '@angular/core';
import { AccountService } from '../../services/account.service';
import { DialogAbstractComponent } from '../dialogs/dialog.class';

@Component({
  selector: 'app-welcome-msg-to-non-corp-user',
  templateUrl: './welcome-msg-to-non-corp-user.component.html',
  styleUrls: ['./welcome-msg-to-non-corp-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class WelcomeMsgToNonCorpUserComponent extends DialogAbstractComponent implements OnInit {
  calsDisabled;
  caltDisabled;
  prdPermissions;
  constructor(injector: Injector, private accountService: AccountService) {
    super(injector);
  }

  async ngOnInit() {
    try {
      this.prdPermissions = await this.accountService.getSignUpPermission();
    } catch (e) {}

    this.calsDisabled = !(
      this.prdPermissions &&
      this.prdPermissions.HIDE_CALS_DIGITAL_SIGNUP &&
      this.dialogParams.currentUser.priviledges.some((priviledge) => priviledge === 'EQUITY_SIGN_UP')
    );

    this.caltDisabled = !(
      this.prdPermissions &&
      this.prdPermissions.HIDE_CALT_DIGITAL_SIGNUP &&
      this.dialogParams.currentUser.priviledges.some((priviledge) => priviledge === 'TREASURY_SIGN_UP')
    );
  }
  close() {
    this.closeDialog(false);
  }
}
